import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
import { useCallback } from 'react';
import { useCompanies } from '../companyQueries';
import SearchSelect from '../../../components/SearchSelect';
import I18n from 'I18n';

const mapCompanyToOption = ({
  name,
  id
}) => ({
  text: name,
  value: id
});

const createOptions = (input, results) => {
  if (!input || results.find(company => company.name.localeCompare(input, undefined, {
    sensitivity: 'base'
  }) === 0)) {
    return results.map(mapCompanyToOption);
  }

  return [{
    text: input,
    value: input
  }, ...results.map(mapCompanyToOption)];
};

const mapOptionToCompany = ({
  text,
  value
}) => ({
  name: text,
  id: value
});

const CompanySelect = ({
  value,
  placeholder,
  onChange
}) => {
  const {
    getCompanies
  } = useCompanies();
  const handleChange = useCallback(v => {
    onChange(v ? mapOptionToCompany(v) : null);
  }, [onChange]);
  const handleLoad = useCallback((input, callback, pagination = {
    offset: 0
  }) => {
    getCompanies(input, pagination.offset).then(data => {
      callback(null, {
        options: createOptions(input, data.results),
        pagination: {
          /**
           * We basically turn this into a typeahead search and don't bother with the pagination
           */
          hasMore: false,
          length: data.total,
          offset: data.offset
        }
      });
    });
  }, [getCompanies]);
  return /*#__PURE__*/_jsx(SearchSelect, {
    "aria-label": I18n.text('connectDotCom.companySearch'),
    filterOptions: false // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore hidden prop that we're not supposed to use. TODO after INBOUND
    ,
    ignoreAccents: false // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore hidden prop that we're not supposed to use. TODO after INBOUND
    ,
    ignoreCase: false,
    placeholder: placeholder,
    onChange: handleChange,
    value: value ? mapCompanyToOption(value) : null,
    loadOptions: handleLoad
  });
};

export default CompanySelect;